import Vue from 'vue'
import Vuex from 'vuex'
import {getCookie} from './cookie.js'

Vue.use(Vuex)
let getToken = getCookie("token")
export default new Vuex.Store({
  state: {
    login: {
      token: (getToken == "null" ? "" : getToken),
      state: (getToken == null ? false : true)
    },
    breadcrumb: [
      {
        text: "首页",
        path: ""
      }
    ],
    currTopMenu:undefined , //当前顶级菜单编码
    menuChangeTime : undefined, //顶部菜单选择更新时间
  },
  mutations: {
    changeLogin(state, data) {
      state.login.token = getToken;
      state.login.state = data;
    },
    updateBreadcrumb(state, data) {
      state.breadcrumb = [];
      state.breadcrumb = data;
    },
    updateTopMenu(state, data){
      state.currTopMenu = data;
    },
    updateMenuChangeTime(state, data){
      state.menuChangeTime = data;
    },
  }
});
